import { FunctionComponent } from 'react';
import { take } from 'rxjs/operators';
import { WizardStateWrapper, WizardCurrentStep, WizardState } from '../interfaces/wizard-step';

export interface WizardStepsProps {
  wizardState: WizardStateWrapper;
  currentStep?: WizardCurrentStep;
  setCurrentStepBeforeUnload: (callback: VoidFunction) => void;
  LoadingComponent?: FunctionComponent;
}

export function WizardStep({
  wizardState,
  currentStep,
  LoadingComponent,
  setCurrentStepBeforeUnload
}: WizardStepsProps) {
  if (!currentStep) {
    return null;
  }
  if (wizardState.state === WizardState.LOADING_STEP && LoadingComponent) {
    return <LoadingComponent />;
  }

  const Component = currentStep.component;
  const stepController = currentStep.controller;

  const goBack = () => {
    stepController.goBack.bind(stepController)();
  };

  const completeStep = () => {
    stepController.markAsComplete.bind(stepController)();
  };

  const skipStep = () => {
    stepController.skipStep.bind(stepController)();
  };

  const markDirty = () => {
    stepController.setDirty.bind(stepController)();
  };

  const updateWizardStepFooterProps = (props: object) => {
    stepController.updateWizardStepFooterProps.bind(stepController)(props);
  };

  return (
    <Component
      initialData={stepController.trackedValue}
      onDataChange={(d: object) => {
        stepController.unsavedData = d;
      }}
      controller={stepController}
      back={goBack}
      completeStep={completeStep}
      skip={skipStep}
      markDirty={markDirty}
      setBeforeUnload={(callback: VoidFunction) => {
        setCurrentStepBeforeUnload(callback);
      }}
      closeWizard$={stepController.closeWizard.pipe(take(1)).toPromise()}
      updateWizardStepFooterProps={updateWizardStepFooterProps}
    />
  );
}
